;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('InvoiceShowToolbarController', InvoiceShowToolbarController)

  InvoiceShowToolbarController.$inject = [
    // Angular
    '$scope', '$state', '$uibModal',
    // Managers
    'InvoiceManager',
    // Services
    'UtilService', 'SnackService', 'DisplayService', 'TemplateService', 'PreferencesService',

    // Consts
    'urls',
    // Resolve
    'element', 'template', 'fromToDeposit', 'fromQuote'

  ]

  function InvoiceShowToolbarController (
    // Angular
    $scope, $state, $uibModal,
    // Managers
    InvoiceManager,
    // Services
    UtilService, SnackService, DisplayService, TemplateService, PreferencesService,

    // Consts
    urls,
    // Resolve
    element, template, fromToDeposit, fromQuote

  ) {
    const self = this
    self.$onInit = () => {
      _.extend(self, {
        invoice: element,
        template: template,
        title: element.title,
        modelTitle: element.modelTitle,
        status: element.status,
        invoiceManager: InvoiceManager,
        fromTodeposit: fromToDeposit,
        fromQuote: fromQuote,
        number: getInvoiceNumber(),
        archiveInvoice: archiveInvoice,
        restoreInvoice: restoreInvoice,
        init: init,
        createPreFilledTemplate: createPreFilledTemplate,
        selectPreFilledTemplate: selectPreFilledTemplate,
        modifyPreFilledTemplateTitle: modifyPreFilledTemplateTitle,
        extranet: extranet,
        deleteInvoice: deleteInvoice
      })
      init()
    }

    $scope.$watch(function () {
      return template
    }, function () {
      self.template = template
      self.number = getInvoiceNumber()
    })

    function init () {
      if (!element._id) {
        self.preFilledTemplate = element
      }
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
      })
    }

    function getInvoiceNumber () {
      if (element.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(element, 'invoice', element.numberFormat)
    }

    function archiveInvoice () {
      var content = "Vous êtes sur le point d'archiver cette facture.<br><br>Vous ne pourrez plus la modifier ni la dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?"
      DisplayService.displayConfirm('Archiver', content).then(function () {
        element.archive().then(function () {
          SnackService.snack({
            text: 'Facture archivée !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function restoreInvoice () {
      var content = 'Vous êtes sur le point de restaurer cette facture.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        element.restore().then(function () {
          SnackService.snack({
            text: 'Facture restaurée !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function createPreFilledTemplate (type, preFilledTemplate) {
      preFilledTemplate.lines = element.lines
      preFilledTemplate.title = element.title
      if (preFilledTemplate._id) {
        return DisplayService.displayConfirm('Êtes vous sûr de vouloir continuer ?', 'Vous avez peut-être des modifications non sauvegardées')
          .then(() => {
            return TemplateService.createPreFilledTemplate(type, preFilledTemplate).then((e) => {
              TemplateService.checkTemplatesTitles(type, e).then((allowCreation) => {
                if (allowCreation) {
                  let newPrefilledTemplate = angular.copy(preFilledTemplate)
                  delete newPrefilledTemplate._id
                  newPrefilledTemplate.linkedData = {
                    solica: {
                      interventions: []
                    }
                  }
                  preFilledTemplate.status = 'draft'
                  newPrefilledTemplate.modelTitle = e
                  newPrefilledTemplate.isModel = true
                  newPrefilledTemplate.save().then(() => {
                    SnackService.snack({
                      text: 'Modèle de facture pré-remplie enregistré ici!',
                      delay: 5000
                    })
                    $state.go('invoice.show', { id: newPrefilledTemplate._id })
                  })
                }
              })
            })
          })
      } else {
        TemplateService.createPreFilledTemplate(type, preFilledTemplate).then((e) => {
          TemplateService.checkTemplatesTitles(type, e).then((allowCreation) => {
            if (allowCreation) {
              preFilledTemplate.status = 'draft'
              preFilledTemplate.modelTitle = e
              preFilledTemplate.isModel = true
              preFilledTemplate.save().then(() => {
                SnackService.snack({
                  text: 'Modèle de facture pré-remplie enregistré !',
                  delay: 5000
                })
                $state.go('invoice.show', { id: preFilledTemplate._id })
              })
            }
          })
        })
      }
    }

    function selectPreFilledTemplate (type) {
      return DisplayService.displayConfirm('Êtes vous sûr de vouloir continuer ?', 'Vous avez peut-être des modifications non sauvegardées')
        .then(() => {
          TemplateService.selectPreFilledTemplate(type).then((config) => {
            $state.go('invoice.new', config)
          })
        })
    }

    function modifyPreFilledTemplateTitle (value) {
      let title = 'modifier le nom du modèle'
      return TemplateService.modifyPreFilledTemplateTitle(title, value).then((value) => {
        element.modelTitle = value
        element.save().then(() => {
          SnackService.snack({
            text: 'Nom du modèle modifié !',
            delay: 5000
          })
        })
      })
    }

    function extranet () {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return 'invoice' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        let url = `${urls.extranet}/invoices/${element._id}`
        if (template !== false) {
          url += '/' + template._id
        }
        window.open(url, '_blank')
      })
    }

    function deleteInvoice () {
      DisplayService.confirmDeletion().then(function () {
        self.invoiceManager.delete(element).then(() => {
          if (self.fromTodeposit) {
            const index = self.fromTodeposit.invoiceDeposit.indexOf(element._id)
            if (index > -1) {
              self.fromTodeposit.invoiceDeposit.splice(index, 1)
              self.fromTodeposit.save().then(() => {
                showSuccessAndRedirect()
              })
            }
          } else if (self.fromQuote) {
            self.fromQuote.invoice = null
            self.fromQuote.status = 'signed'
            self.fromQuote.save().then(() => {
              showSuccessAndRedirect()
            })
          } else {
            showSuccessAndRedirect()
          }
        })
      })
    }

    function showSuccessAndRedirect () {
      SnackService.snack({
        text: 'Facture supprimée !',
        delay: 5000
      })
      $state.go('invoice.list')
    }
  }
})(window.angular, window._)
